import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class WalkCallQueryService {

    public GET_Walk_Call_DATA: any;
    public CREATE_WALK_CALL_DATA: any;
    public DELETE_WALK_CALL_DATA: any;

    constructor(public apollo: Apollo) {

        /**Get walk call details */
        this.GET_Walk_Call_DATA =
            gql`

        # $orderId:BigFloat! if numaric
            query getWalkCallValue($orderId:Int!){                           
                allWalkCalls(condition:{orderId:$orderId}) {
                #   edges {
                    nodes {
                        category
                        callDate
                        orderId
                        id
                    }
                  }
                # }
              }
        `;

        /**Store walk call details */
        this.CREATE_WALK_CALL_DATA = gql` 
             mutation CREATE_WALK_CALL_MUTATION($input: CreateWalkCallInput!) {
                createWalkCall(input: $input) {
                    walkCall{
                         orderId        
                     }
                  }
             }
         `;

        this.DELETE_WALK_CALL_DATA = gql`
         mutation sample($input:DeleteWalkCallByIdInput!){
            deleteWalkCallById(input:$input){
              deletedWalkCallId
            }
          }
         `
    }

    /**Get walk call details */
    GET_Walk_Call_DETAILS(currentOrderId) {
        return this.apollo
            .watchQuery({
                query: this.GET_Walk_Call_DATA
                ,
                variables:
                {
                    "orderId": Number.parseInt(currentOrderId)
                },
                fetchPolicy: 'network-only'
            });
    }

    /**Store walk call details */
    CREATE_WALK_CALL_MUTATION(orderId, category, callDate) {
        return this.apollo.mutate({
            mutation: this.CREATE_WALK_CALL_DATA,
            variables: {
                "input": {
                    "walkCall": {
                        "orderId": Number.parseInt(orderId),
                        "category": category,
                        "callDate": callDate
                    }
                }
            },
        })
    }

    DELETE_WALK_CALL(category) {
        return this.apollo.mutate({
            mutation: this.DELETE_WALK_CALL_DATA,
            variables: {
                "input": {
                    "id": category.id
                }
            }
        })
    }
}


// WEBPACK FOOTER //
// I:/1.speKwo/New Spekwo Revamp/admindash/src/app/main/content/apps/queryFiles/walkCall.ts